import React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Chip,
} from "@mui/material";
import { Add as AddIcon, Business as BusinessIcon } from "@mui/icons-material";
import ButtonOne from "../../common/normal-button";

const RCSBrandList = ({ brands, onCreateBrand, onBack }) => (
  <Box>
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      spacing={2}
      sx={{ mb: 4 }}
    >
      <Box>
        <Typography gutterBottom sx={{ fontWeight: 600, fontSize: 24 }}>
          RCS Brands
        </Typography>
        <Typography color="text.secondary" sx={{ fontWeight: 400, fontSize: 14 }}>
          Brands your RCS bots represent. Every bot belongs to a brand.
        </Typography>
      </Box>
      <Stack direction="row" spacing={2}>
        <ButtonOne variant="outlined" onClick={onBack}>
          Bots
        </ButtonOne>
        <ButtonOne variant="contained" startIcon={<AddIcon />} onClick={onCreateBrand}>
          Create Brand
        </ButtonOne>
      </Stack>
    </Stack>

    {brands.length === 0 ? (
      <Paper sx={{ p: 8, textAlign: "center", borderRadius: 2 }}>
        <BusinessIcon sx={{ fontSize: 64, color: "grey.400", mb: 2 }} />
        <Typography variant="h6" gutterBottom color="text.secondary">
          No brands created yet
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Create a brand to start building RCS bots for it.
        </Typography>
      </Paper>
    ) : (
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Brand</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {brands.map((b) => (
              <TableRow key={b.id} hover>
                <TableCell>
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Avatar src={b.logo || undefined} variant="rounded" sx={{ width: 36, height: 36 }}>
                      {b.brand_name?.[0]?.toUpperCase()}
                    </Avatar>
                    <Typography sx={{ fontWeight: 600 }}>{b.brand_name}</Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  {/* Active once any of the brand's bots is approved or later */}
                  <Chip
                    size="small"
                    label={b.status === "ACTIVE" ? "Active" : "Inactive"}
                    color={b.status === "ACTIVE" ? "success" : "default"}
                    variant={b.status === "ACTIVE" ? "filled" : "outlined"}
                  />
                </TableCell>
                <TableCell>{new Date(b.created_at).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);

export default RCSBrandList;
